// Actions
// ========================================================
export const DISMISS = 'go4ellis/Flash/DISMISS';
export const ERROR_FLASH_MESSAGE = 'go4ellis/Flash/ERROR_FLASH_MESSAGE';
export const SUCCESS_FLASH_MESSAGE = 'go4ellis/Flash/SUCCESS_FLASH_MESSAGE';
export const CUSTOM_FLASH_MESSAGE = 'go4ellis/Flash/CUSTOM_FLASH_MESSAGE';

// Reducer Functions
// ========================================================
const dismissReducer = state => ({
  ...DEFAULT_STATE,
});

const errorReducer = (state, message) => ({
  ...state,
  message,
  type: 'error',
  showDismiss: true,
});

const successReducer = (state, { message, scrollIntoView }) => ({
  ...state,
  message,
  scrollIntoView,
  type: 'success',
  showDismiss: true,
});

const customReducer = (state, payload) => {
  return {
    ...state,
    message: payload.message,
    type: payload.type,
    showDismiss: payload.showDismiss,
  };
};

// Action Creators
// ========================================================
export const dismiss = () => {
  return { type: DISMISS };
};

export const error = message => {
  return { type: ERROR_FLASH_MESSAGE, payload: message };
};

export const success = (message, scrollIntoView) => {
  return { type: SUCCESS_FLASH_MESSAGE, payload: { message, scrollIntoView } };
};

export const customFlash = payload => {
  return { type: CUSTOM_FLASH_MESSAGE, payload };
};

// Reducer
// ========================================================
export const DEFAULT_STATE = {
  message: '',
  type: '',
  showDismiss: true,
};

export default function reducer(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case DISMISS:
      return dismissReducer(state);
    case ERROR_FLASH_MESSAGE:
      return errorReducer(state, action.payload);
    case SUCCESS_FLASH_MESSAGE:
      return successReducer(state, action.payload);
    case CUSTOM_FLASH_MESSAGE:
      return customReducer(state, action.payload);
    default:
      return state;
  }
}
